exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sales-chart .sales {\n  background-color: white; }\n\n.sales-chart h3 {\n  font-size: 125%; }\n\n.sales-chart .text-size {\n  font-size: 70%;\n  font-style: italic; }\n\n.sales-chart .capitalize {\n  text-transform: capitalize; }\n\n.conciliacion {\n  background-color: white; }\n\nsales-chart p-calendar * {\n  height: 100% !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/sales/sales-chart.component.scss
// module id = ../../../../../src/app/components/sales/sales-chart.component.scss
// module chunks = main